import {IStateProps} from './model';
import {View} from 'react-native';
import * as React from 'react';
import {useStyles} from '../../../../shared/hooks/styles';
import {Breadcrumbs} from '../../../../shared/components/breadcrumbs';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {ResponsiveView} from '../../../../shared/components/responsiveView';
import {Text} from '../../../../shared/components/text';
import {CustomScrollView} from '../../../../shared/components/scrollView';

export default ({
  poll,
  breadcrumbs,
  children,
  handleSubmit,
  onSubmit,
  submitButton,
  containerStyle,
  titleStyle,
  descriptionStyle,
}: IStateProps) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    sectionContainer: {
      marginTop: 32,
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 24}, {paddingHorizontal: 16}),
      marginBottom: theme.screen.bottomOffset,
    },
    title: {
      marginTop: 42,
      ...theme.fonts.h2,
      marginBottom: 30,
    },
    text: {
      ...mediaOnly(
        DeviceSize.desktop,
        {...theme.fonts.h5Light, marginBottom: 60},
        {...theme.fonts.bodySmallLight, marginBottom: 35},
      ),
    },
    submitWrapper: {
      alignItems: 'center',
      ...mediaOnly(DeviceSize.desktop, {marginTop: 30}, {marginTop: 25}),
    },
  }));
  return (
    <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
      <View style={styles.sectionContainer}>
        {breadcrumbs ? <Breadcrumbs routes={breadcrumbs} /> : null}
        <View style={[containerStyle]}>
          <ResponsiveView only={[DeviceSize.desktop]}>
            <Text testID={`poll-name-${poll.id}-id`} style={[styles.title, titleStyle]}>
              {poll.name}
            </Text>
          </ResponsiveView>
          <Text testID={`poll-description-${poll.id}-id`} style={[styles.text, descriptionStyle]}>
            {poll.descriptionWelcome}
          </Text>
          {children}
          <View style={styles.submitWrapper}>{submitButton(handleSubmit(onSubmit))}</View>
        </View>
      </View>
    </CustomScrollView>
  );
};
